import { Link } from '@/Framework/Router/Next/Link';
import { Label } from '@dealroadshow/uikit/core/components/Badge/Label';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import type IDealCellData from '@/finsight/ui/components/deals/DealListTable/cells/types';

import styles from './sector.scss';

export const Sector = ({ row: deal }: { row: IDealCellData }) => {
  return (
    <Tooltip content={ `${ deal.dealTypeObject.name }: ${ deal.dealTypeSubObject.name } ` }>
      <Link
        to={ deal.sectorIndustryLink }
        onClick={ (event) => event.stopPropagation() }
        dataTest="dealRowSectorIndustryLink"
      >
        <Label
          backgroundColor={ deal.dealTypeObject.color }
          className={ styles.sectorLabel }
        >
          { deal.dealTypeObject.abbreviation }
        </Label>
      </Link>
    </Tooltip>
  );
};
